import React from "react";
import { Box } from "@material-ui/core";
import { Route, Switch } from "react-router-dom";
import RequireAuth from "components/hoc/require-auth";
import {
  Login,
  ToursList,
  TourDetail,
  AddTour,
  EditTour,
  CustomersList,
  CustomerDetail,
  CurrentRoutes,
  AddCustomer,
  EditCustomer,
  AddOrder,
  OrderList,
  EditOrder,
  PastDeliveries,
  RoutesMap,
  RoutesMapDebug,
  HandoversList,
  ZipcodesList,
  ZipcodeAdd,
  ZipcodeEdit,
  ZipcodesVisualization,
  RecentRoutes,
  ArchiveRoutes,
  ExportRoute,
  AddWithExistingCustomerData,
  ArchivedMap,
  CustomersArchive,
} from "views";
import { PATHS } from "../../util/appConstants";
import Redirect from "./Redirect";
import RecentsMap from "views/Routes/RecentsMap";
import DeliveryHistory from "views/DeliveryHistory/DeliveryHistory";
import SupplierLocationList from "views/Admin/SupplierLocationList";
import SupplierLocationDetail from "views/Admin/SupplierLocationDetails";
import AddSupplierLocation from "views/Admin/AddSupplierLocation";
import AddSupplierGroup from "views/Admin/AddSupplierGroup";
import EditSupplierLocation from "views/Admin/EditSupplierLocation";
import AccountDetails from "views/Admin/AccountDetails";
import EditAccountDetails from "views/Admin/EditAccountDetails";
import SupplierGroupList from "views/Admin/SupplierGroupList";
import SupplierGroupDetail from "views/Admin/SupplierGroupDetails";
import EditSupplierGroup from "views/Admin/EditSupplierGroup";
import RoleList from "views/Admin/RoleList";
import RoleDetail from "views/Admin/RoleDetails";
import EditRole from "views/Admin/EditRole";
import AddRole from "views/Admin/AddRole";
import PermissionList from "views/Admin/PermissionList";
import PermissionDetail from "views/Admin/PermissionDetails";
import EditPermission from "views/Admin/EditPermission";
import AddPermission from "views/Admin/AddPermission";
import SupplierList from "views/Admin/SupplierList";
import SupplierDetail from "views/Admin/SupplierDetails";
import EditSupplier from "views/Admin/EditSupplier";
import UserList from "views/Admin/UserList";
import AddUser from "views/Admin/AddUser";
import UserDetail from "views/Admin/UserDetails";
import EditUser from "views/Admin/EditUser";
import AccountPermissions from "views/Admin/AccountPermissions";
import DiagnosticsWeb from "views/Diagnostics/Web";
import DiagnosticsWebSettings from "views/Diagnostics/WebSettings";
import DiagnosticsFeedbackDetail from "views/Diagnostics/FeedbackDetail";
import DiagnosticsMobile from "views/Diagnostics/Mobile";
import DiagnosticsMobileSettings from "views/Diagnostics/MobileSettings";
import DiagnosticsMobileRouteLogs from "views/Diagnostics/MobileRouteLogs";
import DiagnosticsMobileLogDetail from "views/Diagnostics/MobileLogDetail";
import EditAccountPermission from "views/Admin/EditAccountPermission";
import AddSupplier from "views/Admin/AddSupplier";


const AppRouter = () => {
  return (
    <Box minHeight="100vh" maxWidth="100%">
      <Box minHeight="100vh">
        <Switch>
          <Route exact path={PATHS.login} component={Login} />
          {/**tours */}
          <Route exact path={PATHS.tours.root} component={RequireAuth(ToursList)} />
          <Route exact path={PATHS.tours.add} component={RequireAuth(AddTour)} />
          <Route exact path={PATHS.tours.edit} component={RequireAuth(EditTour)} />
          <Route exact path={PATHS.tours.detail} component={RequireAuth(TourDetail)} />
          <Route
            exact
            // Tours is replaced with routes at UI and URL level
            path={PATHS.routes.current}
            component={RequireAuth(CurrentRoutes)}
          />
          <Route exact path={PATHS.routes.recent} component={RequireAuth(RecentRoutes)} />
          <Route exact path={PATHS.routes.archive} component={RequireAuth(ArchiveRoutes)} />
          <Route exact path={PATHS.routes.export} component={RequireAuth(ExportRoute)} />
          {/**customers */}
          <Route exact path={PATHS.customers.root} component={RequireAuth(CustomersList)} />
          <Route exact path={PATHS.customers.archive} component={RequireAuth(CustomersArchive)} />
          <Route
            exact
            path={PATHS.customers.detail}
            component={RequireAuth(() => (
              <CustomerDetail type="update" />
            ))}
          />
          <Route
            exact
            path={PATHS.customers.view}
            component={RequireAuth(() => (
              <CustomerDetail type="edit" />
            ))}
          />
          <Route exact path={PATHS.customers.add} component={RequireAuth(AddCustomer)} />
          <Route exact path={PATHS.customers.edit} component={RequireAuth(EditCustomer)} />
          <Route
            exact
            path={PATHS.customers.addWithExistingData}
            component={RequireAuth(AddWithExistingCustomerData)}
          />
          <Route exact path={PATHS.orders.root} component={RequireAuth(OrderList)} />
          <Route exact path={PATHS.orders.add} component={RequireAuth(AddOrder)} />
          <Route exact path={PATHS.orders.edit} component={RequireAuth(EditOrder)} />
          <Route exact path={PATHS.pastdeliveries} component={RequireAuth(PastDeliveries)} />
          <Route exact path={PATHS.deliveryhistory} component={RequireAuth(DeliveryHistory)} />
          <Route exact path={`${PATHS.tours.map}/:routeId?/:stopIndex?`} component={RequireAuth(RoutesMap)} />
          <Route exact path={`${PATHS.routes.mapRecent}/:routeId?/:stopIndex?`} component={RequireAuth(RecentsMap)} />
          <Route
            exact
            path={`${PATHS.routes.mapArchive}/:routeId?/:stopIndex?`}
            component={RequireAuth(ArchivedMap)}
          />
          <Route exact path={"/routes/map/debug/:routeId?"} component={RequireAuth(RoutesMapDebug)} />
          <Route exact path={PATHS.handovers.completed} component={RequireAuth(HandoversList)} />
          <Route exact path={PATHS.handovers.root} component={RequireAuth(HandoversList)} />
          <Route exact path={PATHS.zipcodes.root} component={RequireAuth(ZipcodesList)} />
          <Route exact path={PATHS.zipcodes.add} component={RequireAuth(ZipcodeAdd)} />
          <Route exact path={PATHS.zipcodes.edit} component={RequireAuth(ZipcodeEdit)} />
          <Route
            exact
            path={PATHS.zipcodes.visualization}
            component={RequireAuth(ZipcodesVisualization)}
          />
          <Route exact path={PATHS.admin.supplierLocations} component={RequireAuth(SupplierLocationList)} />
          <Route exact path={PATHS.admin.supplierLocationsDetail} component={RequireAuth(SupplierLocationDetail)} />
          <Route exact path={PATHS.admin.supplierLocationsEdit} component={RequireAuth(EditSupplierLocation)} />
          <Route exact path={PATHS.admin.supplierLocationsAdd} component={RequireAuth(AddSupplierLocation)} />
          <Route exact path={PATHS.admin.accountDetails} component={RequireAuth(AccountDetails)} />
          <Route exact path={PATHS.admin.accountDetailsEdit} component={RequireAuth(EditAccountDetails)} />
          <Route exact path={PATHS.admin.supplierGroups} component={RequireAuth(SupplierGroupList)} />
          <Route exact path={PATHS.admin.supplierGroupsDetail} component={RequireAuth(SupplierGroupDetail)} />
          <Route exact path={PATHS.admin.supplierGroupsAdd} component={RequireAuth(AddSupplierGroup)} />
          <Route exact path={PATHS.admin.supplierGroupEdit} component={RequireAuth(EditSupplierGroup)} />
          <Route exact path={PATHS.admin.roles} component={RequireAuth(RoleList)} />
          <Route exact path={PATHS.admin.rolesDetail} component={RequireAuth(RoleDetail)} />
          <Route exact path={PATHS.admin.roleEdit} component={RequireAuth(EditRole)} />
          <Route exact path={PATHS.admin.rolesAdd} component={RequireAuth(AddRole)} />
          <Route exact path={PATHS.admin.permissions} component={RequireAuth(PermissionList)} />
          <Route exact path={PATHS.admin.permissionsDetail} component={RequireAuth(PermissionDetail)} />
          <Route exact path={PATHS.admin.permissionEdit} component={RequireAuth(EditPermission)} />
          <Route exact path={PATHS.admin.permissionAdd} component={RequireAuth(AddPermission)} />
          <Route exact path={PATHS.admin.suppliers} component={RequireAuth(SupplierList)} />
          <Route exact path={PATHS.admin.supplierDetail} component={RequireAuth(SupplierDetail)} />
          <Route exact path={PATHS.admin.supplierGroupsAdd} component={RequireAuth(AddSupplierGroup)} />
          <Route exact path={PATHS.admin.supplierEdit} component={RequireAuth(EditSupplier)} />
          <Route exact path={PATHS.admin.supplierAdd} component={RequireAuth(AddSupplier)} />
          <Route exact path={PATHS.admin.users} component={RequireAuth(UserList)} />
          <Route exact path={PATHS.admin.usersAdd} component={RequireAuth(AddUser)} />
          <Route exact path={PATHS.admin.usersDetail} component={RequireAuth(UserDetail)} />
          <Route exact path={PATHS.admin.usersEdit} component={RequireAuth(EditUser)} />
          <Route exact path={PATHS.admin.accountPermissions} component={RequireAuth(AccountPermissions)} />
          <Route exact path={PATHS.admin.accountPermissionEdit} component={RequireAuth(EditAccountPermission)} />
          <Route exact path={PATHS.diagnostics.web} component={RequireAuth(DiagnosticsWeb)} />
          <Route exact path={PATHS.diagnostics.webSettings} component={RequireAuth(DiagnosticsWebSettings)} />
          <Route exact path={PATHS.diagnostics.feedbackDetail} component={RequireAuth(DiagnosticsFeedbackDetail)} />
          <Route exact path={PATHS.diagnostics.mobile} component={RequireAuth(DiagnosticsMobile)} />
          <Route exact path={PATHS.diagnostics.mobileSettings} component={RequireAuth(DiagnosticsMobileSettings)} />
          <Route exact path={PATHS.diagnostics.mobileRouteLogs} component={RequireAuth(DiagnosticsMobileRouteLogs)} />
          <Route exact path={PATHS.diagnostics.mobileLogDetail} component={RequireAuth(DiagnosticsMobileLogDetail)} />
          <Redirect component={RequireAuth(Redirect)} />
        </Switch>
      </Box>
    </Box>
  );
};

export default AppRouter;
